import { render } from "./case.vue?vue&type=template&id=1f08d56b"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"

import exportComponent from "D:\\丹捷\\项目新\\source\\web_site\\sirimuch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__